function Column() {}

export default Column;
